export default __webpack_public_path__ + "static/media/alert-red.03e2cf0c.svg";